import React from "react";
import { AzimutCompass, AzimutSearch } from "./AzimutIcons";
import { Button } from "./Button";
import { Icon } from "./Icon";
/**
 * Stable workspace scaffolding. Navigation is independent of route content:
 * collapsing context must never unmount the editor, route outlet or dialogs.
 * @summary Azimut header, navigation and working canvas with a keyboard skip link.
 */
export function AzimutWorkspaceFrame({
  banners,
  header,
  navigation,
  children,
  overlays,
  skipLabel
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "az-workspace"
  }, /*#__PURE__*/React.createElement("a", {
    className: "az-skip-link",
    href: "#azimut-main"
  }, skipLabel), banners, header, /*#__PURE__*/React.createElement("div", {
    className: "az-workspace-body"
  }, navigation, /*#__PURE__*/React.createElement("main", {
    className: "az-workspace-main",
    id: "azimut-main",
    tabIndex: -1
  }, children)), overlays);
}

/** @summary One workspace bar, reusing the application's profile/workspace menu slot. */
export function AzimutWorkspaceBar({
  homeHref,
  onHomeClick,
  searchLabel,
  onSearch,
  userControls
}) {
  return /*#__PURE__*/React.createElement("header", {
    className: "az-workspace-bar"
  }, /*#__PURE__*/React.createElement("a", {
    className: "az-wordmark",
    href: homeHref,
    onClick: onHomeClick,
    "aria-label": "Azimut"
  }, /*#__PURE__*/React.createElement(AzimutCompass, {
    className: "az-wordmark-symbol"
  }), /*#__PURE__*/React.createElement("span", null, "AZIMUT")), /*#__PURE__*/React.createElement("div", {
    className: "az-workspace-bar-actions"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline",
    size: "sm",
    icon: AzimutSearch,
    label: searchLabel,
    onClick: onSearch
  }), /*#__PURE__*/React.createElement("div", {
    className: "az-workspace-user"
  }, userControls)));
}

/**
 * Always-labeled module access, separate from the collapsible context tree.
 * Labels remain visible on touch; tooltips are not the only way to identify icons.
 * @summary Persistent global module navigation with shape and aria-current selection.
 */
export function AzimutModuleRail({
  items,
  label,
  onNavigate,
  footer
}) {
  return /*#__PURE__*/React.createElement("nav", {
    className: "az-module-rail",
    "aria-label": label
  }, /*#__PURE__*/React.createElement("div", {
    className: "az-module-links"
  }, items.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.id,
    ref: item.containerRef
  }, /*#__PURE__*/React.createElement("a", {
    className: "az-module-link",
    href: item.disabled ? undefined : item.href,
    "aria-current": item.selected ? "page" : undefined,
    "aria-disabled": item.disabled || undefined,
    onClick: event => {
      if (item.disabled) {
        event.preventDefault();
      } else {
        onNavigate === null || onNavigate === void 0 || onNavigate(event, item);
      }
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    visual: item.icon,
    size: "sm"
  }), /*#__PURE__*/React.createElement("span", null, item.label))))), footer && /*#__PURE__*/React.createElement("div", {
    className: "az-module-footer"
  }, footer));
}
//# sourceMappingURL=AzimutWorkspace.js.map